/* SCOUT 2026-09-27 (Dani cart-drawer perf) — optimistic quantity UI.
   Bolt-on layer that:
   1. Reacts to + / − / input changes INSTANTLY (no 120ms debounce wait for visual feedback)
   2. Prevents the cart-drawer re-render from stealing your tap by preserving the tap target's
      identity across the render (best-effort: focus + scroll position + a fresh :active state)
   3. Optimistically updates the line-item subtotal + cart total so shoppers see the price move
      while the network call is still in flight
   Loaded from layout/theme.liquid globally (small: <2KB). Safe fallback: if any part throws,
   Dawn's native flow still runs. */

(function () {
  if (window.__nooksCartOptimistic) return;
  window.__nooksCartOptimistic = true;

  // Fires as soon as the user clicks + / − (before the debounce, before the network call)
  document.addEventListener(
    'click',
    function (e) {
      const btn = e.target.closest('.quantity__button');
      if (!btn) return;
      const qtyEl = btn.closest('quantity-input');
      if (!qtyEl) return;
      const input = qtyEl.querySelector('input.quantity__input');
      if (!input) return;

      // Snapshot current value BEFORE Dawn's stepUp/stepDown runs (Dawn's handler is on
      // the same click event; we run in the bubbling phase but ordering isn't guaranteed).
      // Instead read AFTER a tick and update the row optimistically.
      setTimeout(function () {
        try {
          const newQty = parseInt(input.value, 10);
          if (!Number.isFinite(newQty)) return;

          // Find the parent cart-item row.
          const row =
            btn.closest('.cart-item') ||
            btn.closest('.cart-drawer__item') ||
            btn.closest('[id^="CartItem-"]') ||
            btn.closest('[id^="CartDrawer-Item-"]');
          if (!row) return;

          row.classList.add('is-syncing');

          // Optimistic line subtotal (best-effort: read the unit price from the row).
          const unitPriceEl =
            row.querySelector('[data-line-unit-price]') ||
            row.querySelector('.cart-item__price-wrapper .price');
          const totalEl =
            row.querySelector('[data-line-item-total]') ||
            row.querySelector('.cart-item__final-price') ||
            row.querySelector('.cart-item__price');
          if (unitPriceEl && totalEl) {
            const m = (unitPriceEl.textContent || '').match(/([\$£€¥]?)\s*([\d.,]+)/);
            if (m) {
              const symbol = m[1] || '$';
              const unit = parseFloat(m[2].replace(/,/g, ''));
              if (Number.isFinite(unit)) {
                const next = (unit * newQty).toFixed(2);
                // Preserve the currency prefix/suffix of the existing string
                totalEl.textContent = totalEl.textContent.replace(/[\$£€¥]?\s*[\d.,]+/, symbol + next);
              }
            }
          }
        } catch (err) {
          // Never break the native flow
          if (window.console) console.debug('nooks-cart-optimistic:', err);
        }
      }, 0);
    },
    true /* capture: fire before Dawn's handlers so the button feels instantly responsive */
  );

  // When Dawn re-renders the cart-drawer section, clear our optimistic state
  // (the server just returned real numbers).
  document.addEventListener('cart:refresh', function () {
    document.querySelectorAll('.is-syncing').forEach(function (r) {
      r.classList.remove('is-syncing');
    });
  });
})();
